<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M15.6473 29.324C14.7362 30.2253 13.2565 30.2253 12.3454 29.324L0.683327 17.7869C-0.227775 16.8856 -0.227775 15.4218 0.683327 14.5205C1.59443 13.6192 3.07406 13.6192 3.98516 14.5205L14 24.428L24.0148 14.5277C24.9259 13.6264 26.4056 13.6264 27.3167 14.5277C28.2278 15.429 28.2278 16.8928 27.3167 17.7941L15.6546 29.3312L15.6473 29.324ZM27.3094 3.94243L15.6473 15.4795C14.7362 16.3808 13.2565 16.3808 12.3454 15.4795L0.683327 3.94243C-0.227776 3.0411 -0.227776 1.57733 0.683327 0.676C1.59443 -0.225334 3.07406 -0.225334 3.98516 0.676L14 10.5835L24.0148 0.683212C24.9259 -0.218122 26.4056 -0.218122 27.3167 0.683212C28.2278 1.58454 28.2278 3.04831 27.3167 3.94964L27.3094 3.94243Z"
      fill="currentColor"
    />
  </svg>
</template>
